import React from 'react';
import c from 'classnames';

import { Button, Stack, Typography } from '@lyearn/ui';

import { maxW200, maxW300 } from './styles';
import { SidebarEmptyStateProps } from './types';

const SidebarEmptyState: React.FC<SidebarEmptyStateProps> = (props) => {
  const { primaryAction, description, Icon, className, width = 'wide' } = props;

  return (
    <Stack
      alignItems="center"
      className={c(className, width === 'narrow' ? maxW200 : maxW300, 'mx-auto')}
      direction="col"
      justifyContent="center">
      {Icon ? (
        <Icon
          data-testid="empty-state-icon"
          fillColorToken="icon-placeholder"
          height={32}
          width={32}
        />
      ) : null}
      <Typography className="mt-12 text-center" color="text-text-placeholder" variant="label-02">
        {description}
      </Typography>
      {primaryAction ? (
        <Stack alignItems="center" className="mt-24" direction="row" justifyContent="center">
          <Button
            appearance="secondary"
            shape="pill"
            size="small"
            variant="outlined"
            onClick={primaryAction.onClick}>
            {primaryAction.label}
          </Button>
        </Stack>
      ) : null}
    </Stack>
  );
};

export default SidebarEmptyState;
